// needed to make jquery available for not bundled scripts
window.$ = window.jQuery = require('jquery');
// dependencies for CKEDITOR
// @todo: this won't work for app in directory
// window.CKEDITOR_BASEPATH = '/vendor/softworx/rocXolid/plugins/ckeditor4/';

export default {

};